import "./LeanLabel.scss";

import React from "react";

export interface LeanLabelProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name?: string;
  title: string;
  required?: boolean;
}

export const LeanLabel: React.FC<LeanLabelProps> = ({ name, title, required }) => {
  return (
    <label className="sbb-label" htmlFor={name}>
      {title}
      {required && <span className="text-danger ml-1">*</span>}
    </label>
  );
};
